"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var getChild = function getChild(id, children) {
  var list = children ? _react["default"].Children.toArray(children) : [];
  var result = null;

  if (list === null || list === void 0 ? void 0 : list.length) {
    result = list.find(function (child) {
      var _child$props;

      return (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id) === id;
    });
  }

  return result;
};

var getNext = function getNext(value, children) {
  var result = null;

  if (value && (children === null || children === void 0 ? void 0 : children.length)) {
    var list = _react["default"].Children.toArray(children),
        current = list.find(function (child) {
      var _child$props2;

      return (child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.id) === value;
    }),
        currentIndex = list.indexOf(current),
        rest = list.slice(currentIndex + 1),
        nextStep = rest.find(function (child) {
      var _child$props3;

      return !!(child === null || child === void 0 ? void 0 : (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.id);
    });

    if (nextStep) {
      result = nextStep.props.id;
    }
  }

  return result;
};

var getPrev = function getPrev(value, children) {
  var result = null;

  if (value && (children === null || children === void 0 ? void 0 : children.length)) {
    var list = _react["default"].Children.toArray(children),
        current = list.find(function (child) {
      var _child$props4;

      return (child === null || child === void 0 ? void 0 : (_child$props4 = child.props) === null || _child$props4 === void 0 ? void 0 : _child$props4.id) === value;
    }),
        currentIndex = list.indexOf(current),
        prev = list.slice(0, currentIndex).reverse(),
        prevStep = prev.find(function (child) {
      var _child$props5;

      return !!(child === null || child === void 0 ? void 0 : (_child$props5 = child.props) === null || _child$props5 === void 0 ? void 0 : _child$props5.id);
    });

    if (prevStep) {
      result = prevStep.props.id;
    }
  }

  return result;
};

var StepController = function StepController(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      name = _ref.name;
  var toStep = (0, _react.useCallback)(function (nextValue) {
    if (typeof onChange === 'function') {
      var target = {
        value: nextValue,
        name: name
      };
      onChange({
        target: target,
        currentTarget: target
      });
    }
  }, [onChange]);
  var toNextStep = (0, _react.useCallback)(function () {
    return toStep(getNext(value, children));
  }, [value]);
  var toPrevStep = (0, _react.useCallback)(function () {
    return toStep(getPrev(value, children));
  }, [value]);

  if (!children) {
    if (process && process.env.NODE_ENV !== 'production') {
      window.console.error("Creating StepController without steps.");
    }
  }

  var activeStep = getChild(value, children);

  if (activeStep) {
    return _react["default"].cloneElement(activeStep, {
      toNextStep: toNextStep,
      toPrevStep: toPrevStep,
      toStep: toStep
    });
  } else {
    return null;
  }
};

StepController.propTypes = {
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  children: _propTypes["default"].any
};
var _default = StepController;
exports["default"] = _default;